const largeNumberScales = [
  { logval: 3, name: 'K' },
  { logval: 6, name: 'M' },
  { logval: 9, name: 'B' },
  { logval: 12, name: 'T' },
  { logval: 15, name: 'Q' },
];

const N_BINOM_APPROX = 16;

export default {
  lookupTables: {},

  async addLookupTable(context, route, name) {
    const req = await context.fetch(route);
    const table = await req.json();
    this.lookupTables[name] = table;
  },

  lookupFunc(x, name) {
    const table = this.lookupTables[name];
    if (!table) {
      throw new Error(`Lookup table ${name} has not yet initialized. Initialized: ${Object.keys(this.lookupTables).join(', ')}`);
    }
    const { max, min, entries } = table;
    const range = max - min;
    const numBins = entries.length - 1;
    const boundX = Math.max(min, Math.min(max, x));
    const target = (boundX - min) / range * numBins;
    const iLo = Math.floor(target);
    const iHi = Math.ceil(target);
    if (iLo === iHi) {
      return entries[iLo];
    }

    return (target - iLo) * entries[iHi] + (iHi - target) * entries[iLo];
  },

  formatLargeNumber(x) {
    const logval = Math.log10(x);
    let i = 0;
    while (logval >= largeNumberScales[i].logval && i < largeNumberScales.length) {
      i++;
    }

    if (i === 0) {
      return x.toFixed();
    }
    const onScale = x / 10 ** largeNumberScales[i - 1].logval;
    let decimals = 0;
    if (onScale <= 9.95) {
      decimals = 1;
    }
    return `${onScale.toFixed(decimals)}${largeNumberScales[i - 1].name}`;
  },

  formatPercent(x) {
    if (x === 0) {
      return '0%';
    } else if (x < 0) {
      return `-${module.exports.formatPercent(-x)}`;
    }
    const p = x * 100;
    const logval = Math.log10(p);

    if (logval < -3) {
      return '<0.001%';
    }

    const decimals = p <= 9.95 ?
      1 - Math.floor(logval) :
      0;
    return `${(x * 100).toFixed(decimals)}%`;
  },

  cumsum(arr) {
    const res = [];
    let s = 0;
    for (let i = 0; i < arr.length; i++) {
      s += arr[i];
      res[i] = s;
    }
    return res;
  },

  binomApprox(n, p, rng) {
    if (n <= N_BINOM_APPROX) {
      let s = 0;
      for (let i = 0; i < n; i++) {
        s += rng.float(0, 1) < p ? 1 : 0;
      }
      return s;
    }

    const mu = n * p;
    const sigma = Math.sqrt(n * p * (1 - p));
    let s = 0;
    for (let i = 0; i < N_BINOM_APPROX; i++) {
      s += rng.int(0, 2);
    }
    const z = 2 * (s - N_BINOM_APPROX / 2) / Math.sqrt(N_BINOM_APPROX);
    return Math.max(0, Math.min(n, Math.round(mu + z * sigma)));
  },
};



// WEBPACK FOOTER //
// src/core/mathUtils.js